"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    root: {
      backgroundColor: '#ffffff',
      boxShadow: '0px 3px 6px 0px rgba(0, 0, 0, 0.03)',
      padding: '20px',
      margin: '24px 24px 0px 20px',
      borderRadius: '10px'
    }
  };
}, {
  name: 'Card'
});
exports.useStyles = useStyles;